import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { App } from '../../../App';
import { FullScreenLoader } from '../../../components/Loaders/FullScreenLoader';
import { RevisionSelector } from '../../../components/Publishing/RevisionSelector';
import { RouteBreadCrumbs } from '../../../routes';
import { HorizontalStack, SmartContainer, Stack, Surface } from '../../../styles/Containers';
import { StyledButton } from '../../../styles/matieralui/Button';
import { TopLevelNavigation } from '../../components/Dashboard/TopLevelNavigation';
import { hasAccess, TERM_ALBUM_PLURAL, TERM_LIBRARY, TERM_RECENT } from '../../services/CaptureCollabService';
import { PermissionsEditor } from '../Permission/PermissionsEditor';
import { searchPermissions } from '../Permission/redux/permissions.actions';
import { FullPermissions } from '../Permission/redux/permissions.selectors';
import { EditLibraryForm } from './EditLibraryForm';
import { LibraryNavigation } from './LibraryNavigation';
import { getLibrary, getLibraryRevision } from './redux/library.actions';
import { FullLibraries } from './redux/library.selectors';
export const PageLibrarySettings = () => {


    // New Modal
    const dispatch = useDispatch();
    const storeLibraries = FullLibraries();
    const { id, screen } = useParams();
    const [activeItem, setActiveItem] = useState(null);
    const [trigger, setTrigger] = useState('resting');

    // Get This Item
    useEffect(() => { dispatch(getLibrary(id)) }, [dispatch, id]);

    // Set Active Item
    useEffect(() => {
        if (storeLibraries?.activeItem) setActiveItem(storeLibraries.activeItem);
    }, [storeLibraries.activeItem, storeLibraries])

    const triggerSave = () => {
        setTrigger('save');
        setTimeout(() => setTrigger('resting'), 2000)
    }


    const renderPageNavigation = () => {
        return (<TopLevelNavigation />)
        // return (<LibraryNavigation libraryId={id} />)
    }

    const renderTopBarChildren = () => {
        if (!storeLibraries?.activeItem) return null;
        return (
            <HorizontalStack flex align="center" justify="flex-end">
                <PermissionsEditor
                    modelId={storeLibraries?.activeItem?.id}
                    model="Library"
                    selector={FullPermissions}
                    action={searchPermissions}
                />
                <StyledButton variant='contained' color="pop" onClick={triggerSave}>Save</StyledButton>
            </HorizontalStack>
        )

    }

    const handleRevisionChange = (revision) => {

        // Clear Revision
        if (!revision) setActiveItem(storeLibraries.activeItem);
        else {

            const mergedData = { ...revision.fields, id: revision.modelId }
            setActiveItem(mergedData);
        }
    }

    // Add Revisions
    const sideBarChildren = () => (
        <Stack>

            <Surface>
                <RevisionSelector
                    label="Revisions"
                    item={storeLibraries?.activeItem}
                    model="Library"
                    modelId={storeLibraries?.activeItem?.id}
                    selector={FullLibraries}
                    action={getLibraryRevision}
                    onChange={handleRevisionChange}
                />
            </Surface>

        </Stack >

    )

    // Render Page
    return (
        <App title={`Edit ${TERM_LIBRARY}`}
            pageNavigation={renderPageNavigation}
            topBarChildren={renderTopBarChildren()}
            breadcrumbs={[RouteBreadCrumbs.libraries, { href: `/library/${id}/albums`, title: TERM_ALBUM_PLURAL }, { href: `/library/${id}`, title: TERM_RECENT }]}
        >
            {storeLibraries?.activeItemLoading && (<FullScreenLoader />)}
            {!storeLibraries?.activeItemLoading && (
                <SmartContainer thinking={storeLibraries?.deleteLoading || storeLibraries?.updateLoading}>
                    <EditLibraryForm
                        item={activeItem}
                        childrenSide={sideBarChildren()}
                        trigger={trigger}
                    />
                </SmartContainer>
            )}
        </App>
    )
}